import Member_Entity from "./member";
export default class Member extends Member_Entity {
  static fromList(membersJSON: unknown): Array<Member> {
    const members: Member[] = [];
    if (membersJSON)
      Array.isArray(membersJSON) &&
        membersJSON.forEach((memberJSON) => {
          members.push(new Member(memberJSON));
        });
    return members;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
